var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"correcte-top "},[_c('div',{staticClass:"correct-left"},[_c('img',{attrs:{"src":_vm.user.photo,"alt":""}}),_vm._v("\n        "+_vm._s(_vm.user.name)+"\n    ")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4264b058","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Panel/housework/components/HeaderList.vue
// module id = null
// module chunks = 